/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForPrometheus extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForPrometheus");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForPrometheus.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForPrometheus>): ServiceAccountCredentialsForPrometheus {
        let obj = Object.assign(new ServiceAccountCredentialsForPrometheus(), model);
        ServiceAccountCredentialsForPrometheus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForPrometheus>): ServiceAccountCredentialsForPrometheus {
        if (!model) return null;
        return ServiceAccountCredentialsForPrometheus.newInstance(<ServiceAccountCredentialsForPrometheus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForPrometheus) {
        if (!obj) return;

        models.ServiceAccountCredentialsForPrometheus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForPrometheus): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForPrometheus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * Password. This is a required field.
     */
    password: string;

    /**
     * Endpoint URL. This is a required field.
     */
    prometheus_url: string;

    /**
     * Cloud Provider. This is a required field.
     */
    service_account_type: models.CloudServiceName;

    /**
     * ServiceAccount Id. This is a required field.
     */
    service_account: string;

}
